import {createSlice} from '@reduxjs/toolkit';

const initialState = {

  modals: {
    form: {},
    confirm: {},
    permission: {}
  },
  features: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  permissions: {
    loading: false,
    error: '',
    data: [],
    init: false
  }
};

const permissionSlice = createSlice({
  name: 'permission',
  initialState: initialState,
  reducers: {

    tryLoadFeatures: () => {
    },
    tryLoadPermissions: () => {
    },
    tryAddOrUpdateFeature: () => {
    },
    tryDeleteFeature: () => {
    },
    tryUpdateFeaturesPermissions: () => {
    },
    setFeatures: (state, action) => {
      if (action.payload.create) {

        state.features.data = [...state.features.data, action.payload.create];

      } else if (action.payload.update) {

        state.features.data = state.features.data.map((f) => f.id === action.payload.update.id ? action.payload.update : f);

      } else if (action.payload.delete) {

        state.features.data = state.features.data.filter((f) => f.id !== action.payload.delete.id);

      } else if (action.payload.loading !== undefined) {

        state.features.error = '';
        state.features.loading = action.payload.loading;

      } else {
        state.features.error = action.payload.error;
        state.features.loading = false;
        if (!action.payload.error) {

          state.features.init = true;

          state.features.data = action.payload.data;

        }
      }


    },
    setPermissions: (state, action) => {
      if (action.payload.loading !== undefined) {

        state.permissions.error = '';
        state.permissions.loading = action.payload.loading;

      } else {
        state.permissions.error = action.payload.error;
        state.permissions.loading = false;
        if (!action.payload.error) {

          state.permissions.init = true;

          state.permissions.data = action.payload.data;

        }
      }


    },
    setManageFeatureModals: (state, action) => {
      if (action.payload?.modal) {
        const type = action.payload.isConfirm ? 'confirm' : action.payload.bulkPermission ? 'permission' : 'form';
        state.modals[type].data = action.payload.data;
        state.modals[type].modal = action.payload.modal;
        state.modals[type].ext = action.payload.ext;
      } else {
        state.modals = {...initialState.modals};
      }
    },
    // resetUsers: (state) => {
    //   state[state.selectedTab] = {...initialState[NORMAL_USERS]};
    // },
    resetFeatures: (state) => initialState

  }
});

export const {
  tryLoadFeatures,
  setFeatures,
  resetFeatures,
  setManageFeatureModals,
  tryAddOrUpdateFeature,
  tryDeleteFeature,
  setPermissions,
  tryLoadPermissions,
  tryUpdateFeaturesPermissions

} = permissionSlice.actions;

export default permissionSlice.reducer;
